import _ from 'lodash'
import { KEY, TOKEN_KEY_MAP, AIR_SYSTEM_LOCAL_STORAGE , IQ_AIR_DEVICES_LOCAL_STORAGE,HVAC_TYPES ,MODES, PLATFORM_IOS} from "./constant"
import { getGlobalState } from "./globalState";
import I18n from "../localization";



export function getUrlParams(key, url) {
  const params = url || _.last(window.location.href.split('?'))
  const searchParams = new URLSearchParams(params)
  return searchParams.get(key)
}

export function getDeviceDetails(paramKey, localStorageKey) {
  return (paramKey && getUrlParams(paramKey)) || ((localStorageKey && localStorage.getItem(localStorageKey)))
}
export function getAppVersion() {
  const appVersion = (localStorage.getItem('appVersion'))
  return appVersion
}

export function isiOS() {
   const deviceOS = getDeviceDetails('os', 'deviceOS')
   const deviceType = getDeviceDetails('type', 'deviceType')
 
  return ((deviceOS && deviceOS === PLATFORM_IOS) || (deviceType && deviceType === PLATFORM_IOS))
}

export function isWeb() {
  const isWeb = localStorage.getItem('isWeb');
  return isWeb === 'true';
}

export function getQueryParam(key, getAll) {
  const search = window.location.search;
  const params = new URLSearchParams(search);

  let value = params.get(key)
  if (!value && key === KEY.ORIGIN) {
    value = window.location.origin;
  }

  if (!key && getAll) {
    const paramObj = {}
    for (let value of params.keys()) {
      paramObj[value] = params.get(value);
    }
    return paramObj
  }

  return value
}

export function removeBackslash(str) {
  if (!str) {
    return null
  }
  let newStr = str.toString().replace(/\\"/g, '"')
  return newStr.replaceAll('"', '')
}

export const fetchCrossSiteToken = (method, url, existingHeaders = {}) => {
  if (method === "GET") return existingHeaders;

  for (const [path, key] of Object.entries(TOKEN_KEY_MAP)) {
    if (url.includes(path)) {
      return {
        ...existingHeaders,
        'X-XSRF-TOKEN': getFromLocalStorage(key),
      };
    }
  }

  return existingHeaders;
};

const SENSITIVE_KEYS = [
  'session',
  'userId',
  'email',
  'enlighten_manager_token',
  'token'
]

export function getFromLocalStorage(key) {
  const raw = localStorage.getItem(key);
  if (raw === null || raw === undefined) return `${raw}`;
  const decodeFn = getGlobalState('decodeFn');
  if (decodeFn && SENSITIVE_KEYS.includes(key)) {
    return `${decodeFn(raw)}`;
  }
  return `${raw}`;
}

export const storeCrossSiteToken = (xhr, url) => {
  const csrfToken = xhr.getResponseHeader("x-csrf-token");

  Object.entries(TOKEN_KEY_MAP).forEach(([path, key]) => {
    if (url.includes(path)) {
      setToLocalStorage(key, csrfToken);
    }
  });
};

// Set key and value to Local Storage
export function setToLocalStorage(key, value) {
  if (key && (!_.isNull(value) && !_.isUndefined(value))) {
    const encodeFn = getGlobalState('encodeFn');
    const encoded = (encodeFn && SENSITIVE_KEYS.includes(key)) ? encodeFn(value) : value;
    localStorage.setItem(key, encoded)
  }
}

export function onFocusTextFieldFunc(element_id) {
  document.getElementById(element_id).scrollIntoView({ behavior: "instant", block: "start", inline:"start" }) 
}

export function getSideId(){
  return getGlobalState('siteId')
}

export const getIQAirSystem = () => {
  const data = localStorage.getItem(AIR_SYSTEM_LOCAL_STORAGE + ':' + getSideId())
  return data ? JSON.parse(data) : []
}

export const getIQAirDevices = () => {
  const data = localStorage.getItem(IQ_AIR_DEVICES_LOCAL_STORAGE + ':' + getSideId())
  return data ? JSON.parse(data) : []
}

export const getAirUnit=()=>{
 return  getGlobalState('airUnit')
}

export const isStateChanged=(current,old)=>{
  return !_.isEqual(current,old)
}

export const convertUnit = (value, type = "") => {
  const val = Number(value);
  const isF = getAirUnit() === 'F';

  const snapToStep = (num, step) => {
    return Math.round(num / step) * step;
  };

  function CTOF() {
    const num = (val * 9) / 5 + 32;
    return snapToStep(num, 1); // ✅ integer for °F
  }

  function FTOC() {
    const num = ((val - 32) * 5) / 9;
    return snapToStep(num, 0.5); // ✅ 0.5 step for °C
  }

  if (type === "FTOC") {
    return isF ? FTOC() : snapToStep(val, 0.5);
  }

  return isF ? CTOF() : snapToStep(val, 0.5);
};

export const airRoundOff = (num) => {
  const intg = Math.floor(num)
  const decimal = Number((num - intg).toFixed(1))
  
  const followFahrenheit = getAirUnit() === 'F';
  if(followFahrenheit) return Math.round(num)
  
  let result
  if (decimal < 0.4) {
    result = intg // round to .0
  } else if (decimal < 0.9) {
    result = intg + 0.5 // round to .5
  } else {
    result = intg + 1 // round to next integer
  }

  return Number(result.toFixed(1))
}

export function getHvacType() {
  const airSystem=getIQAirSystem()
  const hvacObj=airSystem?.find(sys => sys['device-id'] === getGlobalState('airDeviceId') )
  return hvacObj?.type || HVAC_TYPES.UNKNOWN
}

export function getAvailableAirModes(){
  const hvacType=getHvacType()
  switch(hvacType){
    case HVAC_TYPES.COOL:
      return [MODES.COOL, MODES.OFF]
    case HVAC_TYPES.HEAT:
      return [MODES.HEAT, MODES.OFF]  
    case HVAC_TYPES.HEAT_COOL:
      return [MODES.AUTO, MODES.HEAT,MODES.COOL,MODES.OFF]    
    case HVAC_TYPES.UNKNOWN:
      return [MODES.OFF]
    default:
      return [MODES.OFF]
  }
}

export function range(min, max, step = 1) {
  const result = [];
  for (let i = min; i <= max; i += step) {
    result.push(i);
  }
  return result;
}
export function inclusiveRange(list, min, max, step) {
  let arr = [];
  if (min>list[0]){
    arr = list.concat(range(min, max + 1, step));
  }else{
    arr = range(list[0], max + 1, step);
  }

  if (arr[arr.length - 1] !== max) {
    arr.push(max);
  }
  return arr;
}

export function getENLMToken() {
  return getFromLocalStorage('enlighten_manager_token') || ''
}

export const getValueFromObject = (object, key) => { return object ? object?.[key] || false : false}

export const getPermissionDeniedToastMessage = (maskedOwnerEmail) => {
  if (maskedOwnerEmail) {
    return I18n.t('mobile.common.permissionDeniedToast', { email: maskedOwnerEmail })
  }
  return I18n.t('mobile.common.permissionDenied')
}

const normalizeCelsiusMin = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return num;

  const decimal = num % 1;
  if (decimal === 0.5 || decimal === 0) return num;
  if (decimal < 0.5 && decimal > 0) return Math.floor(num) + 0.5;
  return Math.ceil(num);
}

export const getSubsetRange = (obj1, obj2, conversion = false) => {
  const toNum = (val) => {
    const num = Number(val);
    return Number.isFinite(num) ? num : null;
  };

  const mins = [
    toNum(obj1?.min),
    toNum(obj2?.min)
  ].filter(v => v !== null);

  const maxs = [
    toNum(obj1?.max),
    toNum(obj2?.max)
  ].filter(v => v !== null);

  if (mins.length === 0 || maxs.length === 0) {
    return {};
  }

  let min = Math.min(...mins);
  let max = Math.max(...maxs);

  if (conversion) {
    min = convertUnit(min);
    max = convertUnit(max);

    
    min = Math.ceil(min);
    max = Math.ceil(max);
  } else {
    if (getAirUnit() !== 'F') {
      min = normalizeCelsiusMin(min);
    }
  }

  return { min, max };
};
export const getAirModeText = (mode) => {
  switch (mode) {
    /* HVAC Modes */
    case 'SMART': 
    return I18n.t(`mobile.iqAirSetting.modes.smartMode`)
    case 'MANUAL': 
    return I18n.t(`mobile.iqAirSetting.modes.manualMode`)
    /* HVAC STATE */
    case 'HEATING': 
    return I18n.t(`mobile.iqAirSetting.modes.heating`)
    case 'COOLING': 
    return I18n.t(`mobile.iqAirSetting.modes.cooling`)
    case 'IDLE': 
    return I18n.t(`mobile.iqAirSetting.modes.idle`)
    case 'UNKNOWN': 
    return '--'
    /* TS MODE */
    case 'AUTO': 
      return I18n.t(`mobile.iqAirSetting.modes.auto`)
    case 'HEAT':
      return I18n.t(`mobile.iqAirSetting.modes.heat`)
    case 'COOL':
      return I18n.t(`mobile.iqAirSetting.modes.cool`)
    case 'OFF':
      return I18n.t(`mobile.iqAirSetting.modes.off`)
    case 'CIRCULATE':
      return I18n.t(`mobile.iqAirSetting.modes.circulate`)
    case 'ON':
      return I18n.t(`mobile.iqAirSetting.modes.on`)
    default:
      return ''
  }
}

export const updateAirSytemInLocalStorage = (airDeviceId, dataToBeUpdated={}) => {
  let systems = getIQAirSystem()
  const airDeviceIndex = systems.findIndex(system => system['device-id'] === airDeviceId)
  if(airDeviceIndex === -1) return
  if(!_.isEmpty(dataToBeUpdated)){
    for (const [key, value] of Object.entries(dataToBeUpdated)) {
      systems[airDeviceIndex][key]=value
    }
    localStorage.setItem(AIR_SYSTEM_LOCAL_STORAGE + ':' + getSideId(), JSON.stringify([...systems]))
  }
}

export const updateAirDeviceInLocalStorage = (airDeviceId, details) => {
  let systems = getIQAirSystem()
  const airDeviceIndex = systems.findIndex(system => system['device-id'] === airDeviceId)
  if(airDeviceIndex === -1) {
    systems.push(details)
  } else {
    systems[airDeviceIndex] = details
  }
  localStorage.setItem(AIR_SYSTEM_LOCAL_STORAGE + ':' + getSideId(), JSON.stringify([...systems]))
}

export const updateIQAirNameInLocalStorage = (iqAirId, name) => {
  const systems = getIQAirSystem()
  for (const [sysIndex, system] of systems.entries()) {
    const iqAirIndex = system['air-devices']?.findIndex(iqAir => iqAir['device-id'] === iqAirId)
    if (iqAirIndex !== -1) {
      system['air-devices'][iqAirIndex].name = name
      break
    }
  }
  localStorage.setItem(AIR_SYSTEM_LOCAL_STORAGE + ':' + getSideId(), JSON.stringify([...systems]))
}

export const validateName = (val) => {
    let errorMessage = null;
    if (val.length < 3 ) {
      return I18n.t('mobile.iqAirSetting.messages.nameShort')
    } else if (val.length > 40) {
      return errorMessage = I18n.t('mobile.iqAirSetting.messages.nameLong')
    }
    else {
      const regex = /^[a-zA-Z0-9 \-'’_]+$/;
      if (!(val.match(regex))) {
        return errorMessage = I18n.t('mobile.iqAirSetting.messages.invalidName')
      } else {
        return true;
      }
    }
}

export const nodeId = (name, id) => `${name.split(' ').join('_')}_${id}`;
export const maskedSn = (val = '') => {
  if (val.length <= 4) return val
  return 'SN: XXXX' + val.slice(-4)
}

export function truncateString(str, maxLength = 16) {
  if (str.length > maxLength) {
    // Truncate the string and append the ellipsis
    return str.substring(0, maxLength) + '...'; 
  } else {
    return str;
  }
}

export const roundSetPointRange = (num) => {
  const decimal = num % 1
  if (decimal === 0.5) return num;
  if (decimal < 0.5 && decimal > 0) {
    return Math.floor(num) + 0.5          
  }
  return Math.ceil(num)
}

export const getComfortRange = (setpoint, comfortRange) => {
  const comfortRangeMultiplier = getAirUnit() === 'F' ? 2 : 1
  const lowerRange = setpoint - (comfortRangeMultiplier * comfortRange.lower)
  const upperRange = setpoint + (comfortRangeMultiplier * comfortRange.upper) 
  return [lowerRange, upperRange]
}

export const transformSetPointRange = (IQAirTemperatureRange, rangeType) =>  {
  const rangeInterval = getAirUnit() === 'F' ? 3 : 1.5
  const heatSetPointRange = IQAirTemperatureRange?.['heat-setpoint-range'] || {}
  const coolSetPointRange = IQAirTemperatureRange?.['cool-setpoint-range'] || {}
  
  const heatRange = {
    min: heatSetPointRange?.min,
    max: heatSetPointRange?.max >= coolSetPointRange?.max ? coolSetPointRange?.max - rangeInterval : heatSetPointRange?.max
  }

  const coolRange = {
    min: coolSetPointRange?.min <= heatSetPointRange?.min ? heatSetPointRange?.min + rangeInterval : coolSetPointRange?.min,
    max: coolSetPointRange?.max
  }
  
  const selectedRange = rangeType === MODES.HEAT ? heatRange : coolRange;
  const convertedMin = convertUnit(selectedRange?.min);
  const convertedMax = convertUnit(selectedRange?.max);

  return { 
    MIN: getAirUnit() === 'F' ? roundSetPointRange(convertedMin) : normalizeCelsiusMin(selectedRange?.min),
    MAX: roundSetPointRange(convertedMax)
  }
}

export const isSetPointsOverlapping = (IQAirPoints, currentType, currentValue) => {
  const {heat_setpoint, cool_setpoint} = IQAirPoints
  const setPointDeadband = getAirUnit() === 'F' ? 3 : 1.5
  const setPointInterval = getAirUnit() === 'F' ? 1 : 0.5
  if (currentType === 'cool_setpoint' && currentValue < (heat_setpoint + setPointDeadband)) return {status: true, adjust: -setPointInterval};
  if (currentType === 'heat_setpoint' && currentValue > (cool_setpoint - setPointDeadband)) return {status: true, adjust: setPointInterval};
  return {status: false}
}

export const allowedMode = (type, availableModes) => {
  const allowedModes = {
    [MODES.HEAT]: [MODES.HEAT, MODES.AUTO],
    [MODES.COOL]: [MODES.COOL, MODES.AUTO]
  }

  return allowedModes[type]?.some(mode => availableModes.includes(mode)) || false
}

export const getMarks = (min, max, isF) => {
  const step = 5; 

  const marks = [min];

  let start = Math.ceil(min / step) * step;

  for (let i = start; i < max; i += step) {
    if (i > min) marks.push(i);
  }

  if (marks[marks.length - 1] !== max) {
    marks.push(max);
  }

  return marks;
};